var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovebtnicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7672 7.74228C17.8353 7.80184 17.8908 7.87433 17.9305 7.95553C17.9703 8.03674 17.9935 8.12504 17.9988 8.21529C18.0042 8.30555 17.9915 8.39597 17.9616 8.48129C17.9317 8.56662 17.8851 8.64514 17.8245 8.71229L10.6525 16.6722C10.5916 16.7396 10.5179 16.7942 10.4357 16.8328C10.3535 16.8714 10.2645 16.8931 10.1737 16.8968C10.083 16.9005 9.99245 16.886 9.90739 16.8543C9.82232 16.8225 9.74446 16.7741 9.67836 16.7118L5.52819 12.8052C5.40368 12.6863 5.3283 12.525 5.31693 12.3532C5.30556 12.1815 5.35904 12.0117 5.4668 11.8774C5.52496 11.8047 5.59731 11.7445 5.67945 11.7005C5.76159 11.6565 5.85181 11.6297 5.94463 11.6217C6.03745 11.6136 6.13094 11.6245 6.21941 11.6537C6.30789 11.6829 6.38951 11.7298 6.45932 11.7915L9.67904 14.6879C9.81348 14.8089 9.99046 14.8715 10.1711 14.8621C10.3517 14.8526 10.5212 14.7718 10.6422 14.6374L16.8109 7.79753C16.9309 7.6644 17.0986 7.5839 17.2776 7.57343C17.4565 7.56296 17.6325 7.62337 17.7672 7.7416V7.74228Z",
    fill: "#2F7054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovebtnicon);
export default __webpack_public_path__ + "static/media/approvebtnicon.f4cfc62ffc47a94020e49c6f9d0ebc55.svg";
export { ForwardRef as ReactComponent };